import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useCallback } from 'react';
import { ContainerTypeLegacy, CreatePileForm, navigateTo, useAuth } from '@amber-ui/core';

function CreatePileRoute() {
  const { acct } = useSearch({ strict: false }) as { acct?: string };
  const { account_id: session_account_id } = useAuth();
  const effectiveAccountId = acct || session_account_id || '';

  const onCreateSuccess = useCallback(
    // oxlint-disable-next-line typescript/no-explicit-any -- FormWrapper onSubmitSuccess receives PileFragmentFragment
    (result: any) => {
      navigateTo('/pile/dashboard', {
        container_name: result.pile_name,
        container_id: result.pile_id,
        container_type: ContainerTypeLegacy.pile,
      });
    },
    []
  );

  return <CreatePileForm account_id={effectiveAccountId} onSubmitSuccess={onCreateSuccess} />;
}

export const Route = createFileRoute('/_auth/_pile/pile/create')({
  component: CreatePileRoute,
});
